import React, { useState } from "react";
import "./PredictionCriteriaBox.css";

const Box = ({
  home,
  away,
  winner,
  margin,
  setWinner,
  setMargin,
  index,
}: {
  home: string;
  away: string;
  winner?: string;
  margin?: number;
  setWinner: (winner: string, index: number) => void;
  setMargin: (margin: number, index: number) => void;
  index: number;
}) => {
  const handleChangeWinner = (event) => {
    setWinner(event.target.value, index);
  };

  const handleChangeMargin = (event) => {
    setMargin(event.target.value, index);
  };

  const optionsHtml = (
    <select
      name="gameprediction"
      id="team-select"
      onChange={handleChangeWinner}
    >
      <option value="none" selected={!winner} disabled hidden>
        --SELECT--
      </option>
      <option value={away} selected={winner === away}>
        {away}
      </option>
      <option value={home} selected={winner === home}>
        {home}
      </option>
    </select>
  );

  return (
    <>
      <div className="PredictionCriteriaBox-container">
        <div className="PredictionCriteriaBox-item">
          <label
            htmlFor="team-select"
            className="PredictionCriteriaBox-entryPrompt"
          >
            Predicted Winner:
          </label>
          <>{optionsHtml}</>
        </div>
        <div className="PredictionCriteriaBox-item">
          <label
            htmlFor="margin-guess"
            className="PredictionCriteriaBox-entryPrompt"
          >
            Margin of Victory:
          </label>
          {!margin ? (
            <input
              type="number"
              id="margin-guess"
              name="margin-guess"
              min="0"
              max="200"
              onChange={handleChangeMargin}
            ></input>
          ) : (
            <input
              type="number"
              id="margin-guess"
              name="margin-guess"
              min="0"
              max="200"
              defaultValue={margin}
              onChange={handleChangeMargin}
            ></input>
          )}
        </div>
      </div>
    </>
  );
};

export default Box;
